import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const firebaseConfig = {
  apiKey: "AIzaSyCVB8hQtHVuXOy9ug3ahT_ouGUwciULg5E",
  authDomain: "behappyradio-37559.firebaseapp.com",
  projectId: "behappyradio-37559",
  storageBucket: "behappyradio-37559.firebasestorage.app",
  messagingSenderId: "690315094745",
  appId: "1:690315094745:web:b516246d8beedd4e722cc8",
  measurementId: "G-EMND6YCP2P"
};
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
